import { render, staticRenderFns } from "./page-tab.vue?vue&type=template&id=68ff2c02&scoped=true&"
import script from "./page-tab.vue?vue&type=script&lang=ts&"
export * from "./page-tab.vue?vue&type=script&lang=ts&"
import style0 from "./page-tab.vue?vue&type=style&index=0&id=68ff2c02&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ff2c02",
  null
  
)

export default component.exports